import script from "./Roles.vue?vue&type=script&setup=true&lang=js"
export * from "./Roles.vue?vue&type=script&setup=true&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=56c15fad&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c15fad"]])

export default __exports__